
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import relationDescriptor from './QBEDialogsDescriptor.json'

export default defineComponent({
    name: 'olap-custom-view-save-dialog',
    components: { Dialog, DataTable, Column },
    props: { propEntity: Object, visible: Boolean },
    data() {
        return {
            relationDescriptor
        }
    }
})
